import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIconPlaybackRate1X = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 14, viewBox: "0 0 20 14", fill: "none", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.10335 0C7.32484 0 7.5044 0.179552 7.5044 0.401042V13.599C7.5044 13.8204 7.32484 14 7.10335 14H4.10466C3.88317 14 3.70361 13.8204 3.70361 13.599V3.56427C3.70361 3.52878 3.67484 3.5 3.63934 3.5C3.62772 3.5 3.61632 3.50315 3.60634 3.50912L1.16601 4.96896C0.898693 5.12887 0.559082 4.93629 0.559082 4.6248V2.33039C0.559082 2.19068 0.631789 2.06104 0.751001 1.98819L3.90811 0.0588402C3.97108 0.0203605 4.04344 0 4.11723 0H7.10335Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M12.4432 3.5C12.5985 3.5 12.7399 3.58972 12.806 3.73028L13.8755 6.00283C14.0183 6.30641 14.4486 6.31081 14.5976 6.01021L15.7317 3.7229C15.7994 3.58637 15.9386 3.5 16.091 3.5H18.918C19.2212 3.5 19.4148 3.82346 19.2714 4.09063L16.876 8.55584C16.8112 8.67676 16.8126 8.82244 16.8799 8.94204L19.3888 13.4023C19.5392 13.6697 19.346 14 19.0393 14H16.247C16.0988 14 15.9627 13.9183 15.8931 13.7875L14.5884 11.3388C14.4364 11.0534 14.0265 11.0561 13.8781 11.3434L12.6183 13.783C12.5495 13.9163 12.412 14 12.262 14H9.42165C9.11422 14 8.92111 13.6683 9.07289 13.401L11.6045 8.94159C11.6723 8.82227 11.6743 8.67661 11.6099 8.55544L9.23723 4.08919C9.09532 3.82208 9.28893 3.5 9.59139 3.5H12.4432Z", fill: props.fill }));
});
export default SvgIconPlaybackRate1X;
